import type { FormInstance } from '@arco-design/web-react';

import { useDeployFormLinkage } from '../../../platform/linkage';
import { APP_INSTANCE_LINKAGE_RULES, type AppInstanceLinkagePropsMap } from './rules';

/** 应用实例表单联动：多 Editor 场景应在父级调用一次，再注入 linkageProps */
export function useAppInstanceDeployFormLinkage(form: FormInstance, enabled = true): Partial<AppInstanceLinkagePropsMap> {
  return useDeployFormLinkage(form, APP_INSTANCE_LINKAGE_RULES, enabled);
}
